'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isVerticalTouchMoveDetected = function isVerticalTouchMoveDetected(e, deltaX, deltaY) {
  var gap = 32;
  var vertical = Math.abs(deltaY);
  var horizontal = Math.abs(deltaX);
  return vertical > horizontal && horizontal < gap;
};

var getSwipeDirection = function getSwipeDirection(deltaX) {
  return deltaX > 0 ? 'LEFT' : 'RIGHT';
};

exports.isVerticalTouchMoveDetected = isVerticalTouchMoveDetected;
exports.getSwipeDirection = getSwipeDirection;